<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :label="'日期'">
              <a-date-picker v-model="queryParam.endTime" format="YYYY-MM-DD" style="width: 100%;" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'盘号'">
              <!-- <el-select v-model="queryParam.appssid" placeholder="请选择">
                <el-option v-for="item in appList" :key="item.appName" :label="item.label" :value="item.appssid">
                </el-option>
              </el-select> -->
              <a-select v-model="queryParam.appssid">
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="search()">{{ $t(I18N_KEY.COUPON + 'search') }}</a-button
              >&nbsp;&nbsp;
            </span>
          </a-col>
        </a-row>
        <a-row> </a-row>
      </a-form>
      <!--表格内容-->
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item>
              <div style="font-weight: bold;  ">当天日期</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div style="font-weight: bold;   ">与昨日对比</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div style="font-weight: bold;  ">说明</div>
            </a-form-item>
          </a-col>
        </a-row>
        <!--        <div class='a-row-divider'></div>-->
        <div style="font-weight: bold;color: #1890FF;padding-bottom: 10px;padding-top: 20px">概览</div>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'日期'">
              <div>{{ dataSource.currentDay.countDate }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'日期'">
              <div>{{ dataSource.lastDay.countDate }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'历史放款总额/笔数'">
              <div>{{ dataSource.currentDay.totalPayment }}/{{ dataSource.currentDay.totalPaymentCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'历史放款总额/笔数'">
              <div>{{ dataSource.lastDay.totalPayment }}/{{ dataSource.lastDay.totalPaymentCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'历史还款总额（全）/笔数'">
              <div>{{ dataSource.currentDay.totalRepay }}/{{ dataSource.currentDay.totalRepayCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'历史还款总额（全）/笔数'">
              <div>{{ dataSource.lastDay.totalRepay }}/{{ dataSource.lastDay.totalRepayCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'历史还款总额（展）/笔数'">
              <div>{{ dataSource.currentDay.totalRepayExtend }}/{{ dataSource.currentDay.totalRepayExtendCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'历史还款总额（展）/笔数'">
              <div>{{ dataSource.lastDay.totalRepayExtend }}/{{ dataSource.lastDay.totalRepayExtendCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'历史还款总额（部分）/笔数'">
              <div>{{ dataSource.currentDay.totalRepayPart }}/{{ dataSource.currentDay.totalRepayPartCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'历史还款总额（部分）/笔数'">
              <div>{{ dataSource.lastDay.totalRepayPart }}/{{ dataSource.lastDay.totalRepayPartCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'历史在贷总额/笔数'">
              <div>{{ dataSource.currentDay.totalLoan }}/{{ dataSource.currentDay.totalLoanCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'历史在贷总额/笔数'">
              <div>{{ dataSource.lastDay.totalLoan }}/{{ dataSource.lastDay.totalLoanCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'新客当日放款/笔数'">
              <div>{{ dataSource.currentDay.paymentNew }}/{{ dataSource.currentDay.paymentNewCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'新客当日放款/笔数'">
              <div>{{ dataSource.lastDay.paymentNew }}/{{ dataSource.lastDay.paymentNewCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'老客当日放款/笔数'">
              <div>{{ dataSource.currentDay.paymentOld }}/{{ dataSource.currentDay.paymentOldCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'老客当日放款/笔数'">
              <div>{{ dataSource.lastDay.paymentOld }}/{{ dataSource.lastDay.paymentOldCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'当日还款（全）/笔数'">
              <div>{{ dataSource.currentDay.todayRepay }}/{{ dataSource.currentDay.todayRepayCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'当日还款（全）/笔数'">
              <div>{{ dataSource.lastDay.todayRepay }}/{{ dataSource.lastDay.todayRepayCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'当日还款（展）/笔数'">
              <div>{{ dataSource.currentDay.todayRepayExtend }}/{{ dataSource.currentDay.todayRepayExtendCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'当日还款（展）/笔数'">
              <div>{{ dataSource.lastDay.todayRepayExtend }}/{{ dataSource.lastDay.todayRepayExtendCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'当日还款（部分）/笔数'">
              <div>{{ dataSource.currentDay.todayRepayPart }}/{{ dataSource.currentDay.todayRepayPartCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'当日还款（部分）/笔数'">
              <div>{{ dataSource.lastDay.todayRepayPart }}/{{ dataSource.lastDay.todayRepayPartCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <!--        111-->
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'新客件均'">
              <div>{{ dataSource.currentDay.paymentNewPer }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'新客件均'">
              <div>{{ dataSource.lastDay.paymentNewPer }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'新客综合日利率'">
              <div>{{ dataSource.currentDay.newRateDay }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'新客综合日利率'">
              <div>{{ dataSource.lastDay.newRateDay }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>(合同金额-放款本金)/合同金额</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'老客件均'">
              <div>{{ dataSource.currentDay.paymentOldPer }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'老客件均'">
              <div>{{ dataSource.lastDay.paymentOldPer }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'老客综合日利率'">
              <div>{{ dataSource.currentDay.oldRateDay }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'老客综合日利率'">
              <div>{{ dataSource.lastDay.oldRateDay }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>(合同金额-放款本金)/合同金额</div>
            </a-form-item>
          </a-col>
        </a-row>
        <!--        <div class='a-row-divider'></div>-->
        <div style="font-weight: bold;color: #1890FF;padding-bottom: 10px;padding-top: 20px">新客</div>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'安装总量'">
              <div>{{ dataSource.currentDay.installTotal }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'安装总量'">
              <div>{{ dataSource.lastDay.installTotal }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>当日</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'投放量'">
              <div>{{ dataSource.currentDay.channelInstall }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'投放量'">
              <div>{{ dataSource.lastDay.channelInstall }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>当日</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'自然量'">
              <div>{{ dataSource.currentDay.organicInstall }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'自然量'">
              <div>{{ dataSource.lastDay.organicInstall }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>当日</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'注册量'">
              <div>{{ dataSource.currentDay.registerCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'注册量'">
              <div>{{ dataSource.lastDay.registerCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>当日</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'创单量'">
              <div>{{ dataSource.currentDay.creditNew }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'创单量'">
              <div>{{ dataSource.lastDay.creditNew }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>总量/去重</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'新客申请数'">
              <div>{{ dataSource.currentDay.applyNew }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'新客申请数'">
              <div>{{ dataSource.lastDay.applyNew }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>当日总（包含非当日注册用户）</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'风控通过率（数量）'">
              <div>{{ dataSource.currentDay.riskNewRate }}（{{ dataSource.currentDay.riskNew }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'风控通过率（数量）'">
              <div>{{ dataSource.lastDay.riskNewRate }}（{{ dataSource.lastDay.riskNew }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>风控决策通过数/申请数</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'放款率（数量）'">
              <!--       37/40        -->
              <div>{{ dataSource.currentDay.paymentRateNew }}（{{ dataSource.currentDay.paymentNewCount }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'放款率（数量）'">
              <div>{{ dataSource.lastDay.paymentRateNew }}（{{ dataSource.lastDay.paymentNewCount }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>放款订单数/申请数</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'信审分单量'">
              <div>{{ dataSource.currentDay.examineTotal }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'信审分单量'">
              <div>{{ dataSource.lastDay.examineTotal }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>当日信审分单量（全天 包括下班后分的单）</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'信审完成量'">
              <div>{{ dataSource.currentDay.examineCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'信审完成量'">
              <div>{{ dataSource.lastDay.examineCount }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div style="line-height: 1.5">
                完成信审的订单数（可能包括： 昨天下班后分的单 + 当天新分的单 + 之前挂起的单）
              </div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'信审通过率（数量）'">
              <div>{{ dataSource.currentDay.examinePassRate }}（{{ dataSource.currentDay.examinePassCount }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'信审通过率（数量）'">
              <div>{{ dataSource.lastDay.examinePassRate }}（{{ dataSource.lastDay.examinePassCount }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>信审通过数/完成信审的订单数</div>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'额度使用率'">
              <div>
                {{ dataSource.currentDay.amountRateNew }}
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'额度使用率'">
              <div>
                {{ dataSource.lastDay.amountRateNew }}
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>放款订单金额/风控授信的金额</div>
            </a-form-item>
          </a-col>
        </a-row>
        <!--        <div class='a-row-divider'></div>-->
        <div style="font-weight: bold;color: #1890FF;padding-bottom: 10px;padding-top: 20px">老客</div>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'老客申请数'">
              <div>{{ dataSource.currentDay.applyOld }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'老客申请数'">
              <div>{{ dataSource.lastDay.applyOld }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'7天复购率'">
              <div>{{ dataSource.currentDay.reloadSevenRate }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'7天复购率'">
              <div>{{ dataSource.lastDay.reloadSevenRate }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>7天前订单 复借数/还款数</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'风控通过率（数量）'">
              <div>{{ dataSource.currentDay.riskOldRate }}（{{ dataSource.currentDay.riskOld }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'风控通过率（数量）'">
              <div>{{ dataSource.lastDay.riskOldRate }}（{{ dataSource.lastDay.riskOld }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>风控决策通过数/申请数</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'放款率（数量）'">
              <div>{{ dataSource.currentDay.paymentRateOld }}（{{ dataSource.currentDay.paymentOldCount }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'放款率（数量）'">
              <div>{{ dataSource.lastDay.paymentRateOld }}（{{ dataSource.lastDay.paymentOldCount }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>放款订单数/申请数</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'额度使用率'">
              <div>
                {{ dataSource.currentDay.amountRateOld }}
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'额度使用率'">
              <div>
                {{ dataSource.lastDay.amountRateOld }}
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>放款订单额度/授信的额度</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'复贷（2）数量'">
              <div>{{ dataSource.currentDay.loanTwo }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'复贷（2）数量'">
              <div>{{ dataSource.lastDay.loanTwo }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>人数</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'复贷（3）数量'">
              <div>{{ dataSource.currentDay.loanThree }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'复贷（3）数量'">
              <div>{{ dataSource.lastDay.loanThree }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>人数</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'复贷（3+）数量'">
              <div>{{ dataSource.currentDay.loanMuch }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'复贷（3+）数量'">
              <div>{{ dataSource.lastDay.loanMuch }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>人数</div>
            </a-form-item>
          </a-col>
        </a-row>
        <!--        <div class='a-row-divider'></div>-->
        <div style="font-weight: bold;color: #1890FF;padding-bottom: 10px;padding-top: 20px">贷后</div>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'新客T-1未还款率'">
              <div>{{ dataSource.currentDay.newT1 }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'新客T-1未还款率'">
              <div>{{ dataSource.lastDay.newT1 }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>下一日订单未还款率（1-提前还款率）</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'新客当日到期单量'">
              <div>{{ dataSource.currentDay.newTodayDue }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'新客当日到期单量'">
              <div>{{ dataSource.lastDay.newTodayDue }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'新客D0未还款率（数量）'">
              <div>{{ dataSource.currentDay.newD0Rate }}（{{ dataSource.currentDay.newD0 }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'新客D0未还款率（数量）'">
              <div>{{ dataSource.lastDay.newD0Rate }}（{{ dataSource.lastDay.newD0 }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>当日新客未提前还款率（1-提前还款率）</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'新客D1逾期率（数量）'">
              <div>{{ dataSource.currentDay.newD1Rate }}（{{ dataSource.currentDay.newD1 }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'新客D1逾期率（数量）'">
              <div>{{ dataSource.lastDay.newD1Rate }}（{{ dataSource.lastDay.newD1 }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>当日新客订单逾期率</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'新客D7逾期率'">
              <div>{{ dataSource.currentDay.newD7 }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'新客D7逾期率'">
              <div>{{ dataSource.lastDay.newD7 }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>7天前新客截止当日逾期率</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'老客当日到期单量'">
              <div>{{ dataSource.currentDay.oldTodayDue }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'老客当日到期单量'">
              <div>{{ dataSource.lastDay.oldTodayDue }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div></div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'老客D0未还款率（数量）'">
              <div>{{ dataSource.currentDay.oldD0Rate }}（{{ dataSource.currentDay.oldD0 }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'老客D0未还款率（数量）'">
              <div>{{ dataSource.lastDay.oldD0Rate }}（{{ dataSource.lastDay.oldD0 }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>当日老客未提前还款率（1-提前还款率）</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'老客D1逾期率（数量）'">
              <div>{{ dataSource.currentDay.oldD1Rate }}（{{ dataSource.currentDay.oldD1 }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'老客D1逾期率（数量）'">
              <div>{{ dataSource.lastDay.oldD1Rate }}（{{ dataSource.lastDay.oldD1 }}）</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>当日老客订单逾期率</div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item :label="'老客D7逾期率'">
              <div>{{ dataSource.currentDay.oldD7 }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="'老客D7逾期率'">
              <div>{{ dataSource.lastDay.oldD7 }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <div>7天前老客截止当日逾期率</div>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </div>
</template>
<script>
import { getDayTotal } from '@/webpublicapi/statistics'
import { getApplist } from '@/webpublicapi/order'
import moment from 'moment/moment'
import Dict from '@/views/webpublic/modules/Dict.vue'

const I18N_KEY = {
  COUPON: 'coupon.'
}
export default {
  components: { Dict },

  data() {
    return {
      I18N_KEY,
      dataSource: {
        currentDay: {},
        lastDay: {}
      },
      queryParam: {
        appssid: '',
        endTime: moment().add('days', -1)
      },
      appList: []
    }
  },
  created() {
    getApplist().then(res => {
      this.appList = res.data || []
      if (this.appList.length && this.appList.length >= 1) {
        this.appList.shift()
      }
      this.queryParam.appssid = this.appList[0].appssid
    })
    this.basicForm = { ...this.defaultBasicForm }
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.search(this.form)
    },
    searchReset() {
      this.queryParam.endTime = moment().add('days', -1)
    },
    search() {
      this.clearData(1)
      this.clearData(2)

      const form = {
        lastDate:
          this.transformTime(this.queryParam.endTime) === null
            ? undefined
            : this.transformTime(this.queryParam.endTime),
        appssid: this.queryParam.appssid
      }

      console.log('form--->', form)

      getDayTotal(form)
        .then(res => {
          if (res.code === 1000) {
            if (res.data) {
              if (res.data.currentDay) this.setData(res.data.currentDay, 1)
              else this.clearData(1)

              if (res.data.lastDay) this.setData(res.data.lastDay, 2)
              else this.clearData(2)
            }
          } else {
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    /*截取拿到/后面的数值并作逗号分隔数值*/
    formattingAmount(num) {
      console.log(num)
      if (!num) return '0.00'

      let ret = num.toFixed(2)
      ret = ret.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return '฿' + ret
    },
    /*截取拿到/前面的数值并作逗号分隔数值*/
    formattingNumber(num) {
      if (!num) return '0'

      let ret = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return ret
    },
    // (合同金额-放款本金)/合同金额
    formattingRate(num) {
      if (!num) return '0.00%'

      let ret = (num * 100).toFixed(2)
      return ret + '%'
    },

    getRate(num1, num2) {
      if (!num1) return '0.00%'

      if (!num2) return 'NaN'

      let ret = ((num1 * 100) / num2).toFixed(2)
      return ret + '%'
    },

    convertData(data) {
      if (typeof data !== 'object' || data === null) return

      for (const key in data) {
        console.log(key)
        let val = data[key]
        console.log(val)
        if (typeof val === 'string') {
          if (val.includes('/')) {
            data[key] = [0, 0]
            let array = val.split('/')
            if (array.length > 0) data[key][0] = Number(array[0])

            if (array.length > 1) data[key][1] = Number(array[1])
          } else if (!val.includes('-')) {
            data[key] = Number(val)
          }
        }
      }

      console.log(data)
    },

    setData(data, type) {
      let showData = {}
      if (type == 1) {
        this.dataSource.currentDay = showData
      } else {
        this.dataSource.lastDay = showData
      }

      this.convertData(data)

      showData.countDate = data.countDate
      showData.totalPayment = this.formattingAmount(data.totalPayment[0])
      showData.totalPaymentCount = this.formattingNumber(data.totalPayment[1])
      showData.totalRepay = this.formattingAmount(data.totalRepay[0])
      showData.totalRepayCount = this.formattingNumber(data.totalRepay[1])
      showData.totalRepayExtend = this.formattingAmount(data.totalRepayExtend[0])
      showData.totalRepayExtendCount = this.formattingNumber(data.totalRepayExtend[1])
      showData.totalLoan = this.formattingAmount(data.totalLoan[0])
      showData.totalLoanCount = this.formattingNumber(data.totalLoan[1])
      showData.paymentNew = this.formattingAmount(data.paymentNew[0])
      showData.paymentNewCount = this.formattingNumber(data.paymentNew[1])
      showData.paymentOld = this.formattingAmount(data.paymentOld[0])
      showData.paymentOldCount = this.formattingNumber(data.paymentOld[1])
      showData.paymentNewPer = this.formattingAmount(data.contractNew / data.paymentNew[1])
      showData.newRateDay = this.getRate(data.contractNew - data.paymentNew[0], data.contractNew)
      showData.paymentOldPer = this.formattingAmount(data.contractOld / data.paymentOld[1])
      showData.oldRateDay = this.getRate(data.contractOld - data.paymentOld[0], data.contractOld)
      showData.todayRepay = this.formattingAmount(data.todayRepay[0])
      showData.todayRepayCount = this.formattingNumber(data.todayRepay[1])
      showData.todayRepayExtend = this.formattingAmount(data.todayRepayExtend[0])
      showData.todayRepayExtendCount = this.formattingNumber(data.todayRepayExtend[1])
      showData.installTotal = this.formattingNumber(data.installTotal)
      showData.channelInstall = this.formattingNumber(data.channelInstall)
      showData.organicInstall = this.formattingNumber(data.organicInstall)
      showData.registerCount = this.formattingNumber(data.registerCount)
      showData.creditNew = this.formattingNumber(data.creditNew[0]) + '/' + this.formattingNumber(data.creditNew[1])
      showData.applyNew = this.formattingNumber(data.applyNew)
      showData.riskNew = this.formattingNumber(data.riskNew)
      showData.riskNewRate = this.getRate(data.riskNew, data.applyNew)
      showData.examineTotal = this.formattingNumber(data.examineTotal)
      showData.examineCount = this.formattingNumber(data.examineCount)
      showData.examinePassRate = this.getRate(data.examinePassCount, data.examineCount)
      showData.examinePassCount = this.formattingNumber(data.examinePassCount)
      showData.paymentRateNew = this.getRate(data.paymentNew[1], data.applyNew)
      showData.amountRateNew = this.getRate(data.contractNew, data.amountNew)
      showData.applyOld = this.formattingNumber(data.applyOld)
      showData.reloadSevenRate = this.getRate(data.reloadSeven[0], data.reloadSeven[1])
      showData.riskOldRate = this.getRate(data.riskOld, data.applyOld)
      showData.riskOld = this.formattingNumber(data.riskOld)
      showData.paymentRateOld = this.getRate(data.paymentOld[1], data.applyOld)
      showData.amountRateOld = this.getRate(data.contractOld, data.amountOld)
      showData.loanTwo = this.formattingNumber(data.loanTwo)
      showData.loanThree = this.formattingNumber(data.loanThree)
      showData.loanMuch = this.formattingNumber(data.loanMuch)
      showData.newT1 = this.formattingRate(data.newT1)
      showData.newTodayDue = this.formattingNumber(data.newTodayDue)
      showData.newD0Rate = this.getRate(data.newD0, data.newTodayDue)
      showData.newD0 = this.formattingNumber(data.newD0)
      showData.newD1Rate = this.getRate(data.newD1, data.newTodayDue)
      showData.newD1 = this.formattingNumber(data.newD1)
      showData.newD7 = this.formattingRate(data.newD7)
      showData.oldTodayDue = this.formattingNumber(data.oldTodayDue)
      showData.oldD0Rate = this.getRate(data.oldD0, data.oldTodayDue)
      showData.oldD0 = this.formattingNumber(data.oldD0)
      showData.oldD1Rate = this.getRate(data.oldD1, data.oldTodayDue)
      showData.oldD1 = this.formattingNumber(data.oldD1)
      showData.oldD7 = this.formattingRate(data.oldD7)
      showData.totalRepayPart = this.formattingAmount(data.ext1[0])
      showData.totalRepayPartCount = this.formattingNumber(data.ext1[1])
      showData.todayRepayPart = this.formattingAmount(data.ext2[0])
      showData.todayRepayPartCount = this.formattingNumber(data.ext2[1])
    },
    clearData(type) {
      let initDate = {
        countDate: '',
        totalPayment: '',
        totalPaymentCount: '',
        totalRepay: '',
        totalRepayCount: '',
        totalRepayExtend: '',
        totalRepayExtendCount: '',
        totalLoan: '',
        totalLoanCount: '',
        paymentNew: '',
        paymentNewCount: '',
        paymentOld: '',
        paymentOldCount: '',
        paymentNewPer: '',
        newRateDay: '',
        paymentOldPer: '',
        oldRateDay: '',
        todayRepay: '',
        todayRepayExtend: '',
        installTotal: '',
        channelInstall: '',
        organicInstall: '',
        registerCount: '',
        creditNew: '',
        applyNew: '',
        riskNew: '',
        riskNewRate: '',
        examineTotal: '',
        examineCount: '',
        examinePassRate: '',
        examinePassCount: '',
        paymentRateNew: '',
        amountRateNew: '',
        applyOld: '',
        reloadSevenRate: '',
        riskOldRate: '',
        riskOld: '',
        paymentRateOld: '',
        amountRateOld: '',
        loanTwo: '',
        loanThree: '',
        loanMuch: '',
        newT1: '',
        newTodayDue: '',
        newD0Rate: '',
        newD0: '',
        newD1Rate: '',
        newD1: '',
        newD7: '',
        oldTodayDue: '',
        oldD0Rate: '',
        oldD0: '',
        oldD1Rate: '',
        oldD1: '',
        oldD7: '',
        totalRepayPart: '',
        todayRepayPart: '',
        totalRepayPartCount: '',
        todayRepayPartCount: ''
      }
      if (type === 1) this.dataSource.currentDay = initDate

      if (type === 2) this.dataSource.lastDay = initDate
    }
  }
}
</script>
<style lang="css" scoped>
.table-page-search-wrapper .ant-form-inline .ant-form-item {
  margin-bottom: 10px;
  margin-right: 0;
}

/deep/ .table-page-search-wrapper .ant-form-inline .ant-form-item > .ant-form-item-label {
  width: 180px;
  text-align: left;
}

/deep/ .table-page-search-wrapper .ant-form-inline .ant-form-item .ant-form-item-control {
  width: auto;
}

.a-row-divider {
  border-bottom: 1px solid #ccc;
  margin-top: 6px;
  margin-bottom: 24px;
}

/deep/ .ant-row {
  /*background-color: pink;*/
  /*border: 1 px solid #000000;*/
}

/deep/ .ant-col-6 {
  border-bottom: 1px solid #000000;
}
</style>
